// ¿HAY SEÑAL AHORA? · DIRECTRIZ-PWA F2 (11 oct 2026).
//
// Una sola lectura de `navigator.onLine` para todas las pantallas que
// cambian de comportamiento sin señal (punto de venta, traslados,
// pendientes de enviar). `useSyncExternalStore` evita el `setState` dentro
// de un efecto y deja a React releer el valor en cada evento.
import { useSyncExternalStore } from 'react';

const ventana = () => globalThis.window ?? globalThis;

function suscribir(fn) {
  ventana().addEventListener?.('online', fn);
  ventana().addEventListener?.('offline', fn);
  return () => {
    ventana().removeEventListener?.('online', fn);
    ventana().removeEventListener?.('offline', fn);
  };
}
const leer = () => globalThis.navigator?.onLine !== false;

export function useEnLinea() {
  return useSyncExternalStore(suscribir, leer, leer);
}
